import { render, staticRenderFns } from "./ApprovalRejectionModal.vue?vue&type=template&id=b0b94108&scoped=true&lang=pug"
import script from "./ApprovalRejectionModal.vue?vue&type=script&lang=js"
export * from "./ApprovalRejectionModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRejectionModal.vue?vue&type=style&index=0&id=b0b94108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b94108",
  null
  
)

export default component.exports